import React from "react";
import { cn } from "../lib/utils";

/** Regroupement visuel de champs liés — style plat, même langage que le concours cosplay. */
const SectionCard = ({ title, icon, tone = "default", children, className }) => {
  const Icon = icon;
  const accent = tone === "alert" ? "var(--req)" : "var(--acc)";
  return (
    <div
      className={cn("card-pad p-4 flex flex-col gap-3", className)}
      style={tone === "alert" ? { borderColor: "var(--req-border)", background: "var(--req-soft)" } : undefined}
    >
      {title && (
        <div className="flex items-center gap-2">
          {Icon && <Icon className="h-4 w-4" style={{ color: accent }} />}
          <p className="eyebrow" style={{ color: accent }}>
            {title}
          </p>
        </div>
      )}
      {children}
    </div>
  );
};

export default SectionCard;
